import api from '.'

export const participants = {
  sendNotification (id, message, success, fail) {
    api.authenticatedRequest('POST', `/participants/${id}/notifications`, { message }, success, fail)
  },
  getLoginLink (trialId, participantId, success, fail) {
    api.authenticatedRequest(
      'GET',
      `/trials/${trialId}/participants/${participantId}/grants`,
      null,
      success,
      fail
    )
  },
  createLoginLink (trialId, participantId, body, success, fail) {
    api.authenticatedRequest(
      'POST',
      `/trials/${trialId}/participants/${participantId}/grants`,
      body || {},
      success,
      fail
    )
  },
  get (trialId, participantId, success, fail) {
    api.authenticatedRequest('GET', `/trials/${trialId}/participants/${participantId}`, null, success, fail)
  },
  listStages (trialId, participantId, success, fail) {
    api.authenticatedRequest('GET', `/trials/${trialId}/participants/${participantId}/stages`, null, success, fail)
  },
  upsertStageOverride (trialId, participantId, body, success, fail) {
    api.authenticatedRequest(
      'POST',
      `/trials/${trialId}/participants/${participantId}/stageOverrides`,
      body,
      success,
      fail
    )
  },
  deleteStageOverride (trialId, participantId, stage, stageRecurrence, applyToAllRecurrences, success, fail) {
    const params = new URLSearchParams({ stage: String(stage) })
    if (stageRecurrence != null && stageRecurrence !== '') {
      params.set('stageRecurrence', String(stageRecurrence))
    }
    if (applyToAllRecurrences) {
      params.set('applyToAllRecurrences', 'true')
    }
    api.authenticatedRequest(
      'DELETE',
      `/trials/${trialId}/participants/${participantId}/stageOverrides?${params.toString()}`,
      null,
      success,
      fail
    )
  },
  getPacks (trialId, participantId, success, fail) {
    api.authenticatedRequest('GET', `/trials/${trialId}/participants/${participantId}/packs`, null, success, fail)
  },
  getAvailablePacks (trialId, participantId, success, fail) {
    api.authenticatedRequest('GET', `/trials/${trialId}/participants/${participantId}/packs?availableOnly=true`, null, success, fail)
  },
  assignPack (trialId, participantId, packId, success, fail) {
    api.authenticatedRequest('PUT', `/trials/${trialId}/participants/${participantId}/packs/${packId}`, null, success, fail)
  },
  unassignPack (trialId, participantId, packId, success, fail) {
    api.authenticatedRequest('DELETE', `/trials/${trialId}/participants/${participantId}/packs/${packId}`, null, success, fail)
  },
  listMeetings (trialId, participantId, success, fail) {
    api.authenticatedRequest('GET', `/trials/${trialId}/participants/${participantId}/meetings`, null, success, fail)
  },
  createMeeting (trialId, participantId, data, success, fail) {
    api.authenticatedRequest('POST', `/trials/${trialId}/participants/${participantId}/meetings`, data, success, fail)
  },
  updateMeeting (trialId, participantId, meetingId, data, success, fail) {
    api.authenticatedRequest('PUT', `/trials/${trialId}/participants/${participantId}/meetings/${meetingId}`, data, success, fail)
  },
  deleteMeeting (trialId, participantId, meetingId, success, fail) {
    api.authenticatedRequest('DELETE', `/trials/${trialId}/participants/${participantId}/meetings/${meetingId}`, null, success, fail)
  },
  getTranscriptionLink (trialId, participantId, meetingId, sessionId, success, fail) {
    api.authenticatedRequest('GET', `/trials/${trialId}/participants/${participantId}/meetings/${meetingId}/sessions/${sessionId}/transcription-link`, null, success, fail)
  }
}
